<div class="content">
    <h1>Thank you for your request.</h1>
    <p>We will contact you as soon as possible.</p>
    <button class="default" (click)="onClose()">Ok, got it</button>
</div>